import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, PopoverBody, Row, UncontrolledPopover } from 'reactstrap';

import { logoutUser, setLoading } from '../../actions/userActions';
import { store } from '../../index';
import StarIcon from '../Common/Icons/StarIcon.jsx';
import AvatarImg from './AvatarImg.jsx';

class Avatar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: this.props.showUserMenu,
    };
  }

  toggle = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.showUserMenu !== prevProps.showUserMenu) {
      this.setState({ popoverOpen: this.props.showUserMenu });
    }
  }

  handleLogout() {
    store.dispatch(setLoading(false));
    store.dispatch(logoutUser());
  }

  getDisplayName = (user) => {
    if (user && user.id) {
      if (user.username && user.username !== '') {
        return user.username;
      }
      return `${user.name ? user.name : ''} ${
        user.lastName ? user.lastName : ''
      }`;
    }
    return '';
  };

  getUserLevelProgress = (level, points) => {
    // Build levels
    const levels = [];
    levels.push({ level: 1, from: 0, to: 99 });
    levels.push({ level: 2, from: 100, to: 249 });
    levels.push({ level: 3, from: 250, to: 499 });
    levels.push({ level: 4, from: 500, to: 999 });
    levels.push({ level: 5, from: 1000, to: 1749 });
    levels.push({ level: 6, from: 1750, to: 2749 });
    levels.push({ level: 7, from: 2750, to: 3999 });
    levels.push({ level: 8, from: 4000, to: 5499 });

    for (let i = 0; i < 300; i++) {
      levels.push({
        level: i + 9,
        levelFrom: 5500 + 250 * i,
        levelTo: 5500 + 250 * (i + 1) - 1,
      });
    }

    const currentLevel = levels.find((l) => l.level === Number(level));
    const totalRange = currentLevel.to - currentLevel.from + 1;
    const progressPoints = points - currentLevel.from;
    const progress = Math.round((progressPoints * 100) / totalRange);
    return progress;
  };

  render() {
    const { info, waiting } = this.props;

    return (
      <>
        <Button color="link" id="AvatarMenu" className="ml-0 pl-0 mr-0 pr-0">
          <AvatarImg src={this.props.avatarSrc} />
        </Button>

        <UncontrolledPopover
          placement="bottom"
          isOpen={this.state.popoverOpen}
          target="AvatarMenu"
          trigger="legacy"
          toggle={this.props.openUserMenu}
        >
          <PopoverBody className="avatar-menu">
            <Row>
              <Col className="d-flex flex-row justify-content-end deploy-date">
                {process.env.REACT_APP_VERSION}
              </Col>
              <Col className="d-flex flex-row justify-content-end">
                <Link to="/app/account-settings" className="text-default">
                  <i className="material-icons">settings</i>
                </Link>
              </Col>
            </Row>
            <div className="d-flex flex-row mt--2 align-items-center">
              <div className="col-image">
                <AvatarImg src={this.props.avatarSrc} />
              </div>
              {!waiting &&
                info &&
                info.userPoints !== null &&
                info.userBadges !== null && (
                  <div className="ml-2 profile-points">
                    <h5>{this.getDisplayName(this.props.user)}</h5>
                    <StarIcon /> {info.userPoints}
                    {'pts '}
                    {/* <TrophyIcon />
                    {info.userBadges} */}
                  </div>
                )}
            </div>
            {/* {!waiting && info && info.userLevel && (
              <Row className="mt-1">
                <ProgressBar
                  progress={this.getUserLevelProgress(
                    info.userLevel,
                    info.userPoints
                  )}
                  title={false}
                  total={100}
                />
                Level {info.userLevel}
              </Row>
            )} */}
            <button
              className="btn btn-outline-secondary w-100 mt-2"
              onClick={this.handleLogout}
            >
              {' '}
              Logout{' '}
            </button>
          </PopoverBody>
        </UncontrolledPopover>
      </>
    );
  }
}

export default Avatar;
